import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Brand } from './../../../shared/models/brand.model';


@Component({
  selector: 'app-brand-details-widget',
  templateUrl: './brand-details-widget.component.html',
  styleUrls: ['./brand-details-widget.component.css']
})
export class BrandDetailsWidgetComponent implements OnChanges {

   // setup as observable?
   @Input() item_id?: Observable<any[]>; // impliments on changes.
   @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'full'; // side | abstract | full | side_nav_header

   job: Object;
   job_id;
  brand_id: any;
  brand: any;
  brandUsers: Object;
  brandUsersCount: any;
  brand_type: any;
  user_level: Object;
  baseUploadURL: string;
  metric_qualification_renewal_date: Date;
  today_format: Date;

  agent_qualification_status_expired: any = 0;
  company_global_key_data: any;
  company_global_key: any;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) {
    

   }

   // check for changes. to load data.
   ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.brand_id = changes.item_id.currentValue;
      this.getBrandById(this.brand_id);
      this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.brand_id; // no trailing slash
    }
  }


  // Functions

  getBrandById(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      data => { this.brand = data;
       let res = data[0];

// agent qualification cheker
console.log('Agent Qualification Renewal Date: ', data[0].qualification_renewal_date);

// this.metric_qualification_renewal_date = new Date(this.brand[0].qualification_renewal_date * 1000);
this.metric_qualification_renewal_date = new Date(this.brand[0].qualification_renewal_date);
// this.metric_qualification_renewal_date = data[0].qualification_renewal_date;
this.today_format = new Date(this.gfunc.today);

if (this.metric_qualification_renewal_date <= this.today_format) {
  console.log('NOTICE: This agent qualification has expired');
  this.agent_qualification_status_expired = 1;
}


       this.getBrandType(res.brand_type_id);



     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

  }


  getBrandUsers(brand_id) {
    this._demoService.getBrandUsers(brand_id)
      .subscribe(
        data => { this.brandUsers = data;
       // this.brandUsersCount = this.brandUsers.length;
       // this.getFormUserLevel(this.brandUsers.access_level);
        },
        err => console.error(err),
       //  () =>  console.log('loading L')
      );
  }

  getBrandType(brand_type_id) {
    this._demoService.getBrandBrandType(brand_type_id).subscribe(
       data => { this.brand_type = data; },
       err => console.error(err),
       () => console.log('done loading brand_types')
     );
   }



  
  getFormUserLevel(level) {
    this._demoService.getUserLevel(level).subscribe(
       data => { this.user_level = data;
       // console.log(data);
     },
       err => console.error(err),
      // () => console.log('done loading User Levels')
     );
   }



   brandView(brand_id) {
    this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  }
  
  brandEdit(brand_id) {
    this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  }
  


  
getBrandPasswordKeyHash(model) {
  this._demoService.getBrandPasswordKeyHash(model)
  .pipe(
    this.toastr.observe({
       loading: '... decrypting key',
       success: '🚀 ... Showing Password',
       error: '😡'
    })
  )
  .subscribe(
    data => { 
      this.company_global_key_data = data;
      this.company_global_key = this.company_global_key_data.global_company_key
    
    },
    err => console.error(err),
    () => console.log('done loading company')
  );
}



// copy to clipbard button
// ::@ https://stackoverflow.com/questions/49102724/angular-5-copy-to-clipboard
copyMessage(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.toastr.success(val + '');
}

}
